import { lazyNamed } from 'src/utils/lazyNamed';

export const Campaigns = {
  CampaignsList: lazyNamed(() => import('./containers/CampaignsList'), 'CampaignsList'),
  CampaignOverview: lazyNamed(() => import('./containers/CampaignOverview'), 'CampaignOverview'),
  CampaignCreateForm: lazyNamed(() => import('./containers/CampaignCreateForm'), 'CampaignCreateForm'),
  PositionCreateForm: lazyNamed(() => import('./containers/PositionCreateForm'), 'PositionCreateForm'),
  CampaignSummary: lazyNamed(() => import('./containers/CampaignSummary'), 'CampaignSummary'),
};
